import { Select, MenuItem } from "@mui/material";
import { styled } from "@mui/system";
import { ModalRow, ModalTitle } from "../../components/modal/ModalCard";
import MacAddressImage from "../../assets/images/garbageCan/mac.png";
interface GarbageCanStepProps {
    nGarbagesCan: number;
    setNGarbagesCan: (value: number) => void;
}
const Container = styled("div")({
    marginTop: 10,
    height: 350,
    overflow: "auto",
    padding: 10,
});
const GarbageCanStep = ({
    nGarbagesCan,
    setNGarbagesCan,
}: GarbageCanStepProps) => {
    const NgarbageCans = [1, 2, 3];
    return (
        <Container>
            <ModalRow sx={{ textAlign: "left" }}>
                <ModalTitle>Number of garbages can (*)</ModalTitle>
                <Select
                    size="small"
                    value={nGarbagesCan}
                    sx={{ width: "80%" }}
                    onChange={(e) => setNGarbagesCan(Number(e.target.value))}
                >
                    {NgarbageCans.map((num) => (
                        <MenuItem key={num} value={num}>
                            {num}
                        </MenuItem>
                    ))}
                </Select>
            </ModalRow>
            <ModalRow>
                <ModalTitle></ModalTitle>
                <img width={"35%"} height={"35%"} src={MacAddressImage} />
            </ModalRow>
        </Container>
    );
};
export default GarbageCanStep;
